import { CellTypes, GridColDef } from '@fashionnovateam/nova-ui-toolkit';

export type CounterRow = {
  id: number;
  photo: CellTypes.DataGridCellPhotoParams;
  'last_message.updated_at': CellTypes.DataGridCellCustomParams;
  priority: CellTypes.DataGridCellBadgeParams;
  vendor_contacts: CellTypes.DataGridCellCustomParams;
  fn_contacts: CellTypes.DataGridCellCustomParams;
  style_color: CellTypes.DataGridCellStringParams;
  division: CellTypes.DataGridCellStringParams;
  product_description: CellTypes.DataGridCellCustomParams;
  display_name: CellTypes.DataGridCellStringParams;
  prev_fabric_content: CellTypes.DataGridCellStringParams;
  prev_fabric_weight: CellTypes.DataGridCellStringParams;
  prev_fabric_name: CellTypes.DataGridCellStringParams;
  prev_fabric_type: CellTypes.DataGridCellStringParams;
  request_counter_quote_to_vendor: CellTypes.DataGridCellDateTimeParams;
  prev_sample_status: CellTypes.DataGridCellBadgeParams;
  prev_sample_shipped_at: CellTypes.DataGridCellDateTimeParams;
  prev_sample_tracking_to_vendor: CellTypes.DataGridCellCustomParams;
  prev_sample_vendor_received_at: CellTypes.DataGridCellCustomParams;
  counter_sample_status: CellTypes.DataGridCellBadgeParams;
  counter_sample_shipped: CellTypes.DataGridCellCustomParams;
  counter_sample_tracking: CellTypes.DataGridCellCustomParams;
  counter_sample_received_at: CellTypes.DataGridCellCustomParams;
  counter_quote_status: CellTypes.DataGridCellBadgeParams;
  'counter_quote.ranges.jr_cost': CellTypes.DataGridCellStringParams;
  'counter_quote.ranges.plus_cost': CellTypes.DataGridCellStringParams;
  'counter_quote.ranges.baseline_jr_cost'?: CellTypes.DataGridCellStringParams;
  'counter_quote.ranges.baseline_plus_cost'?: CellTypes.DataGridCellStringParams;
  'counter_quote.moq': CellTypes.DataGridCellStringParams;
  'counter_quote.mcq': CellTypes.DataGridCellStringParams;
  coo: CellTypes.DataGridCellStringParams;
  shipment_mode: CellTypes.DataGridCellStringParams;
  'counter_quote.fabric_content': CellTypes.DataGridCellStringParams;
  fabric_weight: CellTypes.DataGridCellStringParams;
  fabric_type: CellTypes.DataGridCellStringParams;
  'counter_quote.lead_time_in_weeks': CellTypes.DataGridCellStringParams;
  'counter_quote.ro_lead_time_in_weeks': CellTypes.DataGridCellStringParams;
  actions: CellTypes.DataGridCellCustomParams;
};

// Default vendor columns
export const vendorColumns: GridColDef[] = [
  {
    field: 'photo',
    headerName: '',
    render: 'photo',
    sortable: false,
    minWidth: 70,
  },
  {
    field: 'last_message.updated_at',
    headerName: 'Last Message',
    render: 'custom',
    sortable: true,
    minWidth: 200,
    width: 200,
  },
  {
    field: 'priority',
    headerName: 'Priority',
    render: 'badge',
    sortable: true,
    minWidth: 170,
    width: 170,
  },
  {
    field: 'vendor_contacts',
    headerName: 'Team Members',
    render: 'custom',
    display: 'flex',
    sortable: false,
  },
  {
    field: 'fn_contacts',
    headerName: 'FN Contacts',
    render: 'custom',
    display: 'flex',
    sortable: false,
  },
  {
    field: 'style_color',
    headerName: 'Style Color',
    render: 'string',
    display: 'flex',
    sortable: false,
  },
  {
    field: 'division',
    headerName: 'Division',
    render: 'string',
    display: 'flex',
    sortable: false,
  },
  {
    field: 'product_description',
    headerName: 'Product Detail (Website Description)',
    render: 'expandable',
    sortable: false,
    minWidth: 220,
  },
  {
    field: 'display_name',
    headerName: 'Display Name',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 120,
  },
  {
    field: 'prev_fabric_content',
    headerName: 'Prev. Fabric Content',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 150,
  },
  {
    field: 'prev_fabric_weight',
    headerName: 'Prev. Fabric Weight',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 150,
  },
  {
    field: 'prev_fabric_name',
    headerName: 'Prev. Fabric Name',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 150,
  },
  {
    field: 'prev_fabric_type',
    headerName: 'Prev. Fabric Type',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 150,
  },
  {
    field: 'request_counter_quote_to_vendor',
    headerName: 'Requested On',
    render: 'dateTime',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: 'prev_sample_status',
    headerName: 'Prev. Sample Status',
    render: 'badge',
    display: 'flex',
    sortable: false,
    minWidth: 200,
  },
  {
    field: 'prev_sample_shipped_at',
    headerName: 'Prev. Sample Shipped',
    render: 'dateTime',
    display: 'flex',
    sortable: false,
    minWidth: 150,
  },
  {
    field: 'prev_sample_tracking_to_vendor',
    headerName: 'Prev. Sample Tracking',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 150,
  },
  {
    field: 'prev_sample_vendor_received_at',
    headerName: 'Prev. Sample Received',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 170,
  },
  {
    field: 'counter_sample_status',
    headerName: 'Vendor Sample Status',
    render: 'badge',
    display: 'flex',
    sortable: false,
    minWidth: 200,
  },
  {
    field: 'counter_sample_shipped',
    headerName: 'Vendor Sample Shipped',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 170,
  },
  {
    field: 'counter_sample_tracking',
    headerName: 'Vendor Sample Tracking',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 150,
  },
  {
    field: 'counter_sample_received_at',
    headerName: 'Vendor Sample Received',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 150,
  },
  {
    field: 'counter_quote_status',
    headerName: 'Quote Status',
    render: 'badge',
    sortable: false,
    minWidth: 200,
  },
  {
    field: 'counter_quote.ranges.jr_cost',
    headerName: 'JR Cost',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: 'counter_quote.ranges.plus_cost',
    headerName: 'Plus Cost',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: 'counter_quote.moq',
    headerName: 'MOQ',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: 'counter_quote.mcq',
    headerName: 'MCQ',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: 'coo',
    headerName: 'COO',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 120,
  },
  {
    field: 'shipment_mode',
    headerName: 'Shipment Mode',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 120,
  },
  {
    field: 'counter_quote.fabric_content',
    headerName: 'Fabric Content',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: 'fabric_weight',
    headerName: 'Fabric Weight',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 120,
  },
  {
    field: 'fabric_name',
    headerName: 'Fabric Name',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 120,
  },
  {
    field: 'fabric_type',
    headerName: 'Fabric Type',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 120,
  },
  {
    field: 'counter_quote.lead_time_in_weeks',
    headerName: 'Lead Time',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: 'counter_quote.ro_lead_time_in_weeks',
    headerName: 'Reorder Lead Time',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: 'actions',
    headerName: 'Actions  ',
    render: 'custom',
    sortable: false,
    minWidth: 200,
  },
];

// Baseline cost columns that can be added conditionally
export const baselineCostColumns: GridColDef[] = [
  {
    field: 'counter_quote.ranges.baseline_jr_cost',
    headerName: 'Baseline JR Cost',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 150,
  },
  {
    field: 'counter_quote.ranges.baseline_plus_cost',
    headerName: 'Baseline Plus Cost',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 150,
  },
];
